<div id="main" class="myw-content d-flex flex-column flex-fill" *ngIf="!hideCreateProp()">
    <div class="myw-inner myw-container">
        <h1 class="fs-20 text-primary my-4" *ngIf="!showHeaderB()">Create Opportunity</h1>
        <h1 class="fs-20 text-primary my-4" *ngIf="showHeaderB()">Edit Opportunity</h1>
        <form ngNativeValidate autocomplete="off" name="createproposalForm">
            <div *ngIf="envVar.Env == 'FDS_ManualUpload' || envVar.Env == 'SAAS_ManualUpload'" class="iom-section iom-form">
                <div class="row">
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Client Name</label>
                            <span class="required-asterisk">*</span>
                            <input [attr.disabled]="Noaccess == true ? 'disabled' : null" class="form-control" list="cname" placeholder="Enter client name" name="cname"
                                maxlength="30" (change)="loadProjectDetails()" [(ngModel)]="clientName" required />
                            <datalist id="cname" (change)="loadProjectDetails()">
                                <option *ngFor="let client of DistinctClientList" [value]="client">{{client}}</option>
                            </datalist>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Project Name</label>
                            <span class="required-asterisk">*</span>
                            <input  [attr.disabled]="Noaccess == true ? 'disabled' : null" class="form-control" placeholder="Enter project name" list="pname" name="pname"
                                maxlength="30" [(ngModel)]="projectName" required />
                            <datalist id="pname">
                                <option *ngFor="let ProjectName of ProjectDetails" [value]="ProjectName">{{ProjectName}}
                                </option>
                            </datalist>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="envVar.Env != 'SAAS_ManualUpload'">
                        <div class="form-group">
                            <label class="form-label">Opportunity Id</label>
                            <span class="required-asterisk">*</span>
                            <input type="text" class="form-control" name="oppId" maxlength="30" 
                            placeholder="Enter the Opportunity Id" [(ngModel)]="opportunityId" required />
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">                        
                        <div class="form-group">
                            <label class="form-label">Market</label>
                            <span class="required-asterisk">*</span>
                            <select [attr.disabled]="Noaccess == true ? 'disabled' : null" id="market" (change)="GetMarketunit()" class="form-control" name="market"
                                [(ngModel)]="market">
                                <option selected value="{{market}}">{{market}}</option>
                                <option *ngFor="let market of marketList" [value]="market.MarketName"
                                    [selected]="market.MarketName == market">{{market.MarketName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Market Unit</label>
                            <span class="required-asterisk">*</span>
                            <select [attr.disabled]="Noaccess == true ? 'disabled' : null" id="marketunit" class="form-control" name="marketUnit" [(ngModel)]="marketUnit">
                                <option selected value="{{marketUnit}}">{{marketUnit}}</option>
                                <option *ngFor="let marketUnit of filteredMarketUnitList"
                                    [value]="marketUnit.MarketUnitName"
                                    [selected]="marketUnit.MarketUnitName == marketUnit">{{marketUnit.MarketUnitName}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Client Group</label>
                            <span class="required-asterisk">*</span>
                            <select [attr.disabled]="Noaccess == true ? 'disabled' : null" id="cgroup" class="form-control" name="cgroup" [(ngModel)]="clientGroup">
                                <option selected value="{{clientGroup}}">{{clientGroup}}</option>
                                <option *ngFor="let cg of ClientGroupList" [value]="cg.ClientGroupName"
                                    [selected]="cg.ClientGroupName == clientGroup">{{cg.ClientGroupName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4" *ngIf="envVar.Env == 'FDS_ManualUpload'">
                        <div class="form-group">
                            <label class="form-label">Contract Code</label>
                            <span class="required-asterisk">*</span>
                            <input type="text" class="form-control" name="ContractId" maxlength="30" 
                            (keyup)="ValidateOpportunityId($event)" placeholder="Enter the Contract Code" [(ngModel)]="OpportunityContractID" required />
                        </div>
                    </div>  
                    <div class="col-6 col-lg-4" *ngIf="envVar.Env == 'SAAS_ManualUpload'">
                        <div class="form-group">
                            <label class="form-label">Contract Code</label>
                            <!-- <span class="required-asterisk">*</span> -->
                            <input [attr.disabled]="'disabled'" type="text" class="form-control" name="ContractIdSaas" maxlength="30" 
                             placeholder="Enter the Contract Code" [(ngModel)]="OpportunityContractID_SAAS" required />
                        </div>
                    </div>  
                    <div class="col-12">
                        <div [formGroup]="form1">
                            <label class="form-label">User Access (Enterprise ID)</label>
                            <div class="editor-tag">
                                <input placeholder="Add the user names and Use comma/enter for multiple users" #tagInput
                                    type="text" class="form-control input-tag" (keyup)="onKeyUp($event)"
                                    formControlName="tag" />
                                <small class="form-text text-muted">* Optional</small>
                            </div>
                            <div *ngIf="enableBox"
                                class="d-flex flex-wrap align-items-start border rounded pt-2 pb-3 px-3 mt-3">
                                <span class="tag-item iom-selected-item" *ngFor="let tag of tags" name="userAccess">
                                    {{tag}}
                                    <span class="remove-tag" (click)="removeTag(tag)" style="cursor: pointer;">×</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="text-right my-4">
                <button type="button" class="btn btn-primary" (click)="CreateProposal()" *ngIf="!showHeaderB()">Create
                    Opportunity</button>
                <button type="button" class="btn btn-primary" (click)="CreateProposal()"  [ngClass]="{'disabled': !subscribed}" *ngIf="showHeaderB()">Update
                    Opportunity</button>
                <button type="button" style="width: 10%;margin-left: 20px;" class="btn btn-secondary"
                    (click)="navigateToProposalSummary()" *ngIf="showHeaderB() || isMandateCreate">Cancel</button>
            </div>
        </form>
    </div>
</div>
